import { CONTACT } from './contact';

export const SITE = {
  name: 'DoWhile Food',
  url: process.env.REACT_APP_SITE_URL || 'https://dowhilefood.com',
  locale: 'fr_CM',
  defaultTitle: 'DoWhile Food — Burgers, Tacos & Crêpes à Yaoundé',
  defaultDescription:
    'DoWhile Food à Yaoundé : burgers gourmands, tacos généreux, crêpes sucrées ou salées et boissons fraîches. Composez votre repas et commandez en ligne.',
  defaultImage: '/logo512.webp',
  phone: CONTACT.phoneE164,
  email: CONTACT.email,
  address: {
    streetAddress: 'Yaoundé',
    addressLocality: 'Yaoundé',
    addressCountry: 'CM',
  },
  openingHours: ['Mo-Sa 09:00-22:00', 'Su 11:00-20:00'],
  priceRange: '$$',
  servesCuisine: ['Burgers', 'Tacos', 'Crêpes', 'Fast Food'],
};

export const PAGE_SEO = {
  home: {
    title: 'DoWhile Food — Burgers, Tacos & Crêpes à Yaoundé',
    description:
      'Découvrez DoWhile Food : du goût, du plaisir à chaque bouchée. Burgers, tacos, crêpes et boissons préparés avec des ingrédients frais à Yaoundé.',
    path: '/',
  },
  about: {
    title: 'À propos — DoWhile Food Yaoundé',
    description:
      'L\'histoire et les valeurs de DoWhile Food : fraîcheur, générosité, rapidité et passion. Une équipe dédiée à vous régaler à Yaoundé.',
    path: '/apropos',
  },
  menu: {
    title: 'Notre menu — Burgers, Tacos, Crêpes | DoWhile Food',
    description:
      'Parcourez le menu DoWhile Food : burgers, tacos XXL, crêpes sucrées et salées, jus naturels. Composez votre repas avec les ingrédients de votre choix.',
    path: '/menu',
  },
  contact: {
    title: 'Contact & commande — DoWhile Food Yaoundé',
    description:
      'Contactez DoWhile Food à Yaoundé : adresse, téléphone, WhatsApp, email et horaires. Commandez ou posez vos questions.',
    path: '/contact',
  },
};

export function absoluteUrl(path = '', baseUrl = SITE.url) {
  const normalizedBase = baseUrl.replace(/\/$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
}
